import { Component, OnInit } from '@angular/core';
import { SearchService } from '../services/search.service';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HelperService } from '../services/helper.service';

@Component({
  selector: 'app-search-member',
  templateUrl: './search-member.component.html',
  styleUrls: ['./search-member.component.scss']
})
export class SearchMember implements OnInit {
  searchType: any;
  searchText: any;
  searchBy: any;
  members: any = [];
  selectedMember: any;
  searchView: any = '';
  message: any;
  isHide: boolean = true;
  searching: boolean = false;
  viewDropDown: boolean = true;
  viewConfirmation: boolean = false;

  constructor(private searchService: SearchService,private router: Router, private modal: NgbActiveModal,private helperService: HelperService) { }

  ngOnInit() {
    if(this.searchView === 'AccountManagement') {
      this.viewDropDown = false;
      this.searchBy = 'Member Number';
    }
  }

  search() {
    this.triggerLoading(true);
    if(this.searchType && this.viewDropDown) {
      this.searchBy = this.searchType;
    }
    switch(this.searchBy) {
      case 'Name':
        this.searchByMemberName(this.searchText);
        break;
      case 'Tour Name':
        this.searchByTourName(this.searchText);
        break;
      case 'Member Number':
        this.searchByMemberNumber(this.searchText);
        break;
      case 'Tour ID':
        this.searchByTourId(this.searchText);
        break;
      case 'HOP Number':
        this.searchByHOPNumber(this.searchText);
        break;
    }
  }

  triggerLoading(loading) {
    this.helperService.setLoading(loading);
  }

  searchByMemberName(name) {
    if(name) {
      this.searching = true;
      this.searchService.searchByMemberName(name)
      .subscribe(res => {
        this.members = res;
        this.searching = false;
        this.triggerLoading(true);
        console.log(this.members, 'members');
      })
    }
  }

  searchByTourName(tourName) {
    if(tourName) {
      this.message = false;
      this.searching = true;
      this.searchService.searchByLastName(tourName)
      .subscribe((res: any) => {
        if (res.length > 0) {
          this.members = res;
          this.isHide = false;
          this.searching = false;
        } else {
          this.message = 'No tour found with this member name.';
          this.searching = false;
        }
        this.triggerLoading(true);
      });
    }
  }

  searchByMemberNumber(memberNumber) {
    if (memberNumber.match(/^\d+$/)) {
      this.message = false;
      this.searching = true;
      this.searchService.searchByMemberNumber(memberNumber)
        .subscribe((res: any) => {
          if (res.length > 0) {
            this.members = res;
            this.isHide = false;
            this.searching = false;
            console.log(this.members, 'members');
          } else {
            this.message = 'No tour found with this member number.';
            this.searching = false;
          }
          this.triggerLoading(false);
        }, err => {
          this.triggerLoading(false);
        });
    } else {
      this.message = 'Please provide a valid member number.';
      this.triggerLoading(false);
    }
  }

  searchByHOPNumber(hopNumber) {
    this.searching = true;
    this.searchService.searchByHopNumber(hopNumber)
    .subscribe((res: any) => {
      console.log('got byhop response', res);
      if (res.data.orderId) {
        this.openConfirm(res.data);
        this.searching = false;
      } else {
        this.message = 'No tour found with this Hop Number.';
        this.searching = false;
      }
      this.triggerLoading(false);
    })
  }

  searchByTourId(tourId) {
    if (tourId) {
      this.message = false;
      this.searching = true;
      this.searchService.searchMemberByTourId(tourId)
        .subscribe((res: any) => {
          if (res) {
            this.openConfirm(res);
            this.searching = false;
          } else {
            this.message = 'No tour found with this Tour ID.';
            this.searching = false;
          }
          this.triggerLoading(false);
        });
    } else {
      this.message = 'Please provide a valid Tour ID.';
      this.searching = false;
      this.triggerLoading(false);
    }
  }

  getOpenMemberFlag() {
    if(this.searchType === 'In-House Transfer') {
      return false;
    } else {
      return true;
    }
  }

  close() {
    this.modal.close();
  }

  confirmIHT(member) {
    this.searchService.confirmIHT(member)
      .subscribe((res: any) => {
        this.searchType = '';
        member.orderId = res;
        this.openConfirm(member);
      },
      err => {
        console.log(err,'err')
      });
  }

  async openConfirm(member) {
    try {
      if (this.getOpenMemberFlag()) {
        if (this.searchType === 'Refi') {
          let resp = await this.searchService.activateRefinance({ orderId: member.orderId, cashout: false });
          console.log('resp', resp);
        }
        this.router.navigate(['/tour/', member.orderId]);
        if (this.router.url.startsWith('/tour/')) {
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
        this.close();
      } else {
        this.selectedMember = member;
        this.viewConfirmation = true;
      }
    } catch(err) {
      console.error('unexpected error', err);
    }
  }

}
